export const SIDEBAR_SIMILAR_JOBS_COUNT = 4;
export const FOOTER_SIMILAR_JOBS_COUNT = 9;
